import type { BooleanRecord } from "@p-ban/common/src/types"

import type SPEC_CATEGORIES from "../../../constant/specCategories"
import getDisplayCondition from "../../../service/getDisplayCondition"
import type EstimateValues from "../../../types/params"

const getSpecCategoryDisplayCondition = (values: EstimateValues): BooleanRecord<typeof SPEC_CATEGORIES> => {
  const condition = getDisplayCondition(values)

  return {
    base:
      condition.metalBoard || condition.layer || condition.sizeX || condition.sizeY || condition.fpcRectangularShape,
    design: condition.pinCnt || condition.planCadDataKbn || condition.fileKbn,
    manufacture: condition.cnt,
    mount:
      condition.sheetCnt ||
      condition.solderType ||
      condition.pieceCnt ||
      condition.bgacsp ||
      condition.sideOfSmd ||
      condition.dipPartCnt ||
      condition.sideOfDip ||
      condition.metalmask ||
      condition.provisionOfMountData ||
      condition.metalMaskDtl ||
      condition.freeMaterialsFlg ||
      condition.userProvPartFlg ||
      condition.materialsArrivalDate,
    designRequest:
      condition.externalsSilk ||
      condition.otherSilk ||
      condition.planBgacsp ||
      condition.controlWiring ||
      condition.designInstruction ||
      condition.circuit,
    material:
      condition.board ||
      condition.boardThickness ||
      condition.fpcBoardThickness ||
      condition.almThickness ||
      condition.beatenThickness ||
      condition.buildUpMethod,
    designCriteria: condition.minPattern || condition.minLand || condition.laserVia || condition.impedance,
    resistPrinting: condition.resistPrint || condition.resistColor,
    coverlay: condition.coverLaySide || condition.coverLay || condition.coverLayColor,
    silkPrinting: condition.silk || condition.silkColor || condition.silkPrintMethod,
    finishing: condition.surfaceFinishing || condition.hardGoldOnPCIEdgeTerminal || condition.chamferingProcess,
    reinforcementPlate: condition.rfContactPortionCnt || condition.reinForcementCnt,
    imposition:
      condition.panelizedItemCnt ||
      condition.panelizedItemKindCnt ||
      condition.fpcSurfacePutData ||
      condition.vcutCnt ||
      condition.jumpVcutCnt ||
      condition.routerCut ||
      condition.routerCutKind ||
      condition.roulette ||
      condition.rouletteKind ||
      condition.dataService ||
      condition.discardBoardMark ||
      condition.recognizeMark ||
      condition.editVariantSlit,
    specialProcessing:
      condition.semiTh || condition.longHole || condition.padOnVia || condition.padLess03 || condition.emcShield,
    standard: condition.ulMark,
    inspection:
      condition.aoiInspection || condition.manufactureInspectionCertificate || condition.mountInspectionCertificate,
    dataFormat: condition.dxfData || condition.manuOptPlanCad,
    factory: condition.estManuFactoryId,
    specialDesignSpec:
      condition.rigidFlexPcb ||
      condition.wireBonding ||
      condition.awDataSupplied ||
      condition.panelized ||
      condition.ddrEmc ||
      condition.designDaysShortening ||
      condition.dxfDataOutput,
  }
}

export default getSpecCategoryDisplayCondition
